import { createStore } from 'vuex'
import createResourceModule from './createResourceModule'
import settings from './settings'

// Every public content resource the store mirrors, keyed by module name.
// Module names double as the dispatch namespace (`news/fetch`, …), so the
// refetchAll action below derives its list from this map — one source of truth.
export const RESOURCES = {
  news: '/news',
  gallery: '/galereya',
  leadership: '/rahbariyat',
  departments: '/boshqarma',
  documents: '/ochiqMalumotlar',
  videos: '/videos',
  yosholimlar: '/yosholimlar',
  faqs: '/faqs',
  articles: '/ilmiy-maqolalar',
  reports: '/hisobotlar'
}

const modules = Object.fromEntries(
  Object.entries(RESOURCES).map(([name, path]) => [name, createResourceModule({ path })])
)
modules.settings = settings

export default createStore({
  modules,
  actions: {
    // Re-pull every content resource — used when the UI language changes so DB
    // content comes back in the newly selected locale.
    async refetchAll({ dispatch }) {
      await Promise.all(Object.keys(RESOURCES).map((m) => dispatch(`${m}/fetch`, true)))
    }
  }
})
